import { Component, OnInit, Input } from '@angular/core';
import { Project } from '../../../models';
import { AuthService, CalendarService, DialogService, ProjectService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DialogComponent } from '../../common/dialog/dialog.component';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';

@Component({
    selector: 'sn-usc-retail-foundations',
    templateUrl: './usc-retail-foundations.component.html',
    styleUrls: ['./usc-retail-foundations.component.css']
})
export class UscRetailFoundationsComponent implements OnInit {
    // @Input() rf_user_ID: number;
    @Input() rf_ap: any;

    rf_firstname: string;
    rf_lastname: string;
    rf_project: Project;
    rf_dlvb_project: any;
    rf_phase: any;
    is_rf_loaded: boolean = false;
    dlg: NgbModalRef;
    category_classes: any = [];
    is_current_user_rf_owner: boolean = true;
    view: string;


    CAT_CLASS_SHOWN:string = 'shown';
    CAT_CLASS_HIDDEN:string = 'hidden';

    CAT_ICON_CLASS_SHOWN:string = 'fa fa-arrow-circle-down fa-1 arrow';
    CAT_ICON_CLASS_HIDDEN:string = 'fa fa-arrow-circle-up fa-1 arrow';

    constructor(
        public uscStoreService: UscStoreService,
        public projectService: ProjectService,
        public dialogService: DialogService,
        public calendarService: CalendarService,
        public authService: AuthService,
        ) { 
            this.view = this.uscStoreService.view_retail_foundations;
        }

    ngOnInit() {
        this.dlg = this.dialogService.showLoadingDlg(DialogComponent, { msg: "Loading Retail Foundations...", msg_class: "msg-loading-usc-blue" });
        this.is_current_user_rf_owner = this.rf_ap ? false : true;
        var current_user = this.authService.getActive();
        this.rf_firstname = current_user.first_name;
        this.rf_lastname = current_user.last_name;
        if (!this.is_current_user_rf_owner) {
            this.rf_firstname = this.rf_ap.ur_firstname;
            this.rf_lastname = this.rf_ap.ur_lastname;
        }
        this.uscStoreService.getRetailFoundations(this.rf_ap ? this.rf_ap.ur_user_ID : null).subscribe(rf => {
            this.dlg.dismiss();
            this.reload(rf);
            // only need to init category_classes when first loading
            this.initCategoryClasses();
        })
    }


    reload(rf:Project) {
        this.rf_project = rf;
        this.rf_dlvb_project = this.projectService.convertToDeliverableProject(rf);
        this.rf_phase = this.rf_dlvb_project.phases[0];
        this.is_rf_loaded = true;
    }

    initCategoryClasses() {
        var index = 0;
        var bOneShown = false;
        // find the first category with an incomplete deliverable and show that one
        this.rf_phase.categories.forEach(c => {
            var dlvb = c.deliverables.find(d => d.status == "NotStarted");
            this.category_classes.push({ 
                ID: c.ID, 
                class: !bOneShown && dlvb ? this.CAT_CLASS_SHOWN : this.CAT_CLASS_HIDDEN,
                icon_class: !bOneShown && dlvb ? this.CAT_ICON_CLASS_SHOWN : this.CAT_ICON_CLASS_HIDDEN
            })
            // mark oneShown = true, thus making all other ones hidden
            if (!bOneShown && dlvb) bOneShown = true;
        });
    }

	getCategoryClass(category) {
        var cat = this.category_classes.find(c => c.ID == category.ID);
        return cat ? cat.class : this.CAT_CLASS_SHOWN;
	}

    getCategoryIconClass(category) {
        var cat = this.category_classes.find(c => c.ID == category.ID);
        return cat ? cat.icon_class : this.CAT_ICON_CLASS_SHOWN;
    }


    toggleCategory(category) {
        var cat = this.category_classes.find(c => c.ID == category.ID);
        if (cat) {
            if (cat.class == this.CAT_CLASS_SHOWN) cat.class = this.CAT_CLASS_HIDDEN;
            else if (cat.class == this.CAT_CLASS_HIDDEN) cat.class = this.CAT_CLASS_SHOWN;

            if (cat.icon_class == this.CAT_ICON_CLASS_SHOWN) cat.icon_class = this.CAT_ICON_CLASS_HIDDEN;
            else if (cat.icon_class == this.CAT_ICON_CLASS_HIDDEN) cat.icon_class = this.CAT_ICON_CLASS_SHOWN;
        }
    }

    getCompletedDate(dlvb) {
        if (this.isDlvbCompleted(dlvb) && dlvb.completed_date) {
            var date = this.calendarService.getLocalDateFromGMTString(dlvb.completed_date);
            return date.toDateString();
        }
        return "";
    }

    isDlvbCompleted(deliverable) {
        return deliverable.status == 'Completed';
    }

    onDlvbCompletion(e, deliverable) {
        // NOTE: once deliverable is completed, cannot uncheck
        if (this.isDlvbCompleted(deliverable)) { e.target.checked = true; return false; }
        var modalRef = this.dialogService.showDialog(UscDialogComponent, this.uscStoreService.dialog_type_yes_no_prompt, { msg: "Mark this activity as completed?" });
        modalRef.result.then(
            (result) => {
                if (result.response == "yes") {
                    this.dlg = this.dialogService.showLoadingDlg(DialogComponent, { msg: "Updating Retail Foundations...", msg_class: "msg-loading-usc-blue" });
                    this.uscStoreService.completeRetailFoundationDeliverable(deliverable.ID).subscribe(rf => {
                        this.dlg.dismiss();
                        this.uscStoreService.updateRetailFoundations(rf);
                        this.reload(rf);
                    })
                }
            },
            (reason) => { e.target.checked = false; }
        )
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-retail-foundations/usc-retail-foundations.component.ts